export * from './tab.component';
export * from './tab-content.directive';
export * from './tab-title.directive';
export * from './tabs.component';
export * from './tabs.module';
